<template>
  <div class="select-address-container">
    <van-icon name="arrow-left" class="arrow-left" @click="handleBack" />
    <div class="title">选择收货地址</div>
    <div class="address-list">
      <div
        class="address-item"
        v-for="item in addressList"
        :key="item.id"
        @click="handleSelectAddress(item)"
      >
        <div class="header">
          <div class="radio" :class="{ active: selectAddress === item.id }" />
          <div class="address">
            {{ `${item.province}${item.city}${item.state}${item.address}` }}
          </div>
        </div>
        <div class="content">
          <span class="name">{{ item.recipient_name }}</span>
          <span class="phone">{{ item.recipient_phone_number }}</span>
        </div>
        <van-icon name="edit" class="edit" @click="editAddress(item)" />
      </div>
    </div>
    <div class="add-address" @click="addAddress">新增收货地址</div>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  props: ["addressList", "address"],
  setup(props, { emit }) {
    const selectAddress = ref(props.address.id);

    const editAddress = (item) => {
      emit("editAddress", "edit", item);
    };

    const addAddress = () => {
      emit("editAddress", "add");
    };

    const handleSelectAddress = (item) => {
      selectAddress.value = item.id;
      emit("selectAddress", item);
    };

    const handleBack = () => {
      emit("closePopup");
    };

    return {
      selectAddress,
      editAddress,
      addAddress,
      handleSelectAddress,
      handleBack,
    };
  },
});
</script>

<style lang="less" scoped>
.select-address-container {
  position: relative;

  .arrow-left {
    position: absolute;
    left: 16px;
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  text-align: center;
}

.address-list {
  margin-top: 20px;
  height: 270px;
  overflow-y: auto;
  margin-bottom: 12px;

  .address-item {
    overflow: hidden;
    position: relative;
    height: 79px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;

    .header {
      margin-top: 9px;
      display: flex;
      align-items: center;

      .radio {
        width: 15px;
        height: 15px;
        border: 1px solid #ff9f18;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          &::after {
            content: "";
            display: block;
            width: 10px;
            height: 10px;
            background: #ff9f18;
            border-radius: 50%;
          }
        }
      }

      .address {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        line-height: 24px;
      }
    }

    .content {
      margin-left: 29px;
      margin-top: 14px;

      font-weight: 400;
      font-size: 12px;
      color: #cccccc;
      line-height: 16px;

      .phone {
        margin-left: 10px;
      }
    }

    .edit {
      position: absolute;
      top: 15px;
      right: 0px;
      font-size: 18px;
      color: #999999;
    }
  }
}

.add-address {
  background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
  border-radius: 21px;
  height: 44px;

  font-weight: 500;
  font-size: 16px;
  color: #6c3e0c;
  line-height: 44px;
  text-align: center;
  margin-bottom: 40px;
}
</style>